import { render, staticRenderFns } from "./CartIco.vue?vue&type=template&id=6f3964d8&scoped=true&lang=pug&"
import script from "./CartIco.vue?vue&type=script&lang=js&"
export * from "./CartIco.vue?vue&type=script&lang=js&"
import style0 from "./CartIco.vue?vue&type=style&index=0&id=6f3964d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3964d8",
  null
  
)

export default component.exports